const translationsFr = {
    priceCalculator: {
        ExternalWashingTitle: "Lavage extérieur",
        ExternalWashingDescription: "Nettoyage de la carrosserie extérieure, nettoyage des vitres, nettoyage des jantes, application d'un produit pour les pneus.",
        InternalWashingTitle: "Lavage intérieur",
        InternalWashingDescription: "Aspiration de l'habitacle, nettoyage des tableaux de bord et des vitres intérieures.",
        SanitationTitle: "Désinfection",
        SanitationDescription: "Désinfection des surfaces et purification de l'air du système de climatisation.",
        GlassShieldTitle: "Protection pare-brise",
        GlassShieldDescription: "Revêtement offrant une propriété hydrofuge et d'étanchéité au pare-brise : favorise le glissement des gouttes de pluie, permettant de ne pas utiliser les essuie-glaces au-dessus de 70 km/h.",
        GlassCoatingTitle: "Protection pare-brise",
        GlassCoatingDescription: "Revêtement offrant une propriété hydrofuge et d'étanchéité au pare-brise : favorise le glissement des gouttes de pluie, permettant de ne pas utiliser les essuie-glaces au-dessus de 70 km/h.",
        PolishingTitle: "Polish",
        PolishingDescription: "Application d'une cire de polish qui améliore la brillance de la carrosserie après le lavage.",
        CeramicCoatingTitle: "Revêtement céramique",
        CeramicCoatingDescription: "Traitement pour redonner de l'éclat à la carrosserie, grâce à ses propriétés hydrofuges qui augmentent la durée du lavage et procurent une sensation de douceur au toucher.",
        PremiumTyreDressingTitle: "Traitement pneus premium",
        PremiumTyreDressingDescription: "Application d'un produit de protection de haute qualité qui restaure l'aspect « neuf de l'usine » des pneus pendant des centaines de kilomètres.",
        EngineBayWashingTitle: "Lavage du compartiment moteur",
        EngineBayWashingDescription: "Nettoyage du compartiment moteur, axé sur l'élimination de la poussière et de la graisse des composants.",
        pageTitle: "Où souhaitez-vous réserver le lavage de voiture?",
        selectCityTitle: "Sélectionnez la ville",
        selectCityPlaceholder: "Sélectionnez une ville",
        selectModelTitle: "Sélectionnez le modèle de votre véhicule et découvrez le coût du lavage",
        selectBrandPlaceholder: "Sélectionnez la marque",
        selectModelPlaceholder: "Sélectionnez le modèle",
        servicesNotSelectedInfo: "Pour continuer, veuillez saisir les informations de votre véhicule",
        baseServicesTitle: "Choisissez les services que vous souhaitez",
        premiumServicesTitle: "Ajoutez des services premium (facultatif)",
        washingDurationMessage: "Votre lavage prendra environ {0} minutes",
        genericScooterBrandModel: "Tous",
        baseServicesMissingWarningTitle: "Service de base manquant !",
        baseServicesMissingWarningBody: "Vous devez d'abord sélectionner l'un des services de base.",
        noServicesCombinationWarningTitle: "Combinaison non prise en charge !",
        noServicesCombinationWarningBody: "Il n'est pas possible de déterminer le prix en ajoutant ce service à la combinaison.",
        durationWarningTitle: "La durée du lavage peut varier en fonction de l'état du véhicule",
        resetSearch: "Nouvelle Recherche",
        title: "Les prix du lavage avec Wash Out",
        subtitle: "Pour découvrir le coût du lavage à domicile de votre véhicule, utilisez le menu ci-dessous : lavage intérieur, extérieur, désinfection et services premium.",
        salesForceName: "Prénom",
        salesForceSurname: "Nom",
        salesForceEmail: "Email",
        salesForcePhone: "Téléphone",
        salesForceCompany: "Entreprise",
        salesForceProvince: "Province",
        salesForceMessage: "Message",
        salesForceSubmit: "Envoyer"
    },
    areas: {
        title: "Zones de couverture Wash Out",
        subtitle: "Découvrez les zones de couverture pour chaque ville",
        milanoText: "Milan",
        romaText: "Rome",
        torinoText: "Turin",
        parigiText: "Paris",
    },
    cities: {
        title: "Découvrez les villes où le service est actif",
        searchPlaceholder: "Vérifiez si votre adresse est couverte",
        milanoText: "Milan",
        romaText: "Rome",
        torinoText: "Turin",
        parigiText: "Paris",
        noResultsText: "Désolé, l'adresse sélectionnée n'est pas couverte par le service",
        noResultsButtonText: "Découvrez les villes actives",
        resultsText: "L'adresse est couverte par le service, réservez dès maintenant !",
        resultsButtonText: "Réservez un lavage"
    }
}